import { Component, OnInit, Inject } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { LicenseType } from '@classes/anpr/licenseType';
import { ClientSmartHub } from '@classes/client/client';
import { LicenseService } from '@services/anpr/license.service';
import { ClientService } from '@services/client/client.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { LicenseANPR } from '@classes/anpr/licenseANPR';
import { LicenseStatus } from '@classes/anpr/licenseStatus';

export interface DialogData {
  license: LicenseANPR;
}

@Component({
  selector: 'app-add-license',
  templateUrl: './add-license.component.html',
  styleUrls: ['./add-license.component.scss'],
})
export class AddLicenseComponent implements OnInit {
  addLicenseForm: UntypedFormGroup;
  possibleClients: ClientSmartHub[]; // clients without any license
  types: LicenseType[];
  color: ThemePalette = 'primary';
  // minDate: Date;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private licenseService: LicenseService,
    private clientService: ClientService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    // this.minDate = Date();
  }

  ngOnInit(): void {
    this.getPossibleClients();
    this.getAllTypes();
    this.initForm();
  }

  onSubmit(): void {
    const newLicense = new LicenseANPR();
    // newLicense.id = null;
    newLicense.client = this.addLicenseForm.value.client;
    newLicense.type = this.addLicenseForm.value.type;
    newLicense.startingDate = new Date();
    newLicense.expiryDate = this.addLicenseForm.value.hasExpiryDate
      ? this.addLicenseForm.value.expiryDate
      : null;
    let status = new LicenseStatus(1, 'Active');
    newLicense.status = status;
    newLicense.usesRemaining =
      this.addLicenseForm.value.type.name != 'Unlimited'
        ? this.addLicenseForm.value.uses
        : null;
    newLicense.comment = this.addLicenseForm.value.comment;

    this.licenseService.addLicense(newLicense).subscribe({
      next: () => this.dialog.closeAll(),
    });
  }

  initForm() {
    this.addLicenseForm = this.formBuilder.group({
      client: ['', Validators.required],
      type: ['', Validators.required],
      hasExpiryDate: [''],
      expiryDate: [''],
      uses: ['', Validators.pattern('^[0-9]+$')],
      comment: [''],
    });
  }

  getPossibleClients() {
    this.clientService.getAllClients(true).subscribe((res) => {
      this.possibleClients = res;
    });
  }

  getAllTypes() {
    this.licenseService.getAllTypes().subscribe((res) => {
      this.types = res;
    });
  }
}
